(function recipeScript($, Drupal) {
    Drupal.behaviors.recipe = {
        attach: function (context, settings) {
            $('iframe').each(function () {
//                console.log(this);
//                var newUrl = $(this).attr('src').replace('www.youtube.com', 'www.youtube-nocookie.com');
//                $(this).attr('src', newUrl);
            });
        },
    };
}(jQuery, Drupal));
